import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Routes from './router';
import { history } from "./router/history";
import { SnackbarProvider } from "notistack";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import MainScreen from './layout/main-layout';
import ScrollToTop from './components/ScrollToTop';


const theme = createTheme({
  typography: {
    fontFamily: [
      'Arial',
      'Helvetica',
      "sans-serif"
    ].join(','),
  }
});


function App() {

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <BrowserRouter history={history}>
            <ScrollToTop />
            <MainScreen>
              <Routes />
            </MainScreen>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  )
}

export default App
